import type { ComponentProps } from 'react';
import { DoubleThumbsDown, DoubleThumbsUp } from '@kula-ai/icons-core';

type RatingIconProps = ComponentProps<typeof DoubleThumbsUp>;

// kula icons default to an inline `color: currentColor`; clearing it lets Chakra's `<Icon as color>` class apply, like the old local SVGs
export const StrongYesIcon = (props: RatingIconProps) => (
  <DoubleThumbsUp color="" {...props} />
);

export const StrongNoIcon = (props: RatingIconProps) => (
  <DoubleThumbsDown color="" {...props} />
);
